/**
 * @desc 暂存区明细分页
 */
const URL = "/rantion-wms";
import http, { updateResponse } from "@/http";
export function request(params: API.wms.stagingAreaMaster.detailPage.Params, options?: any) {
  return updateResponse(
    http(URL + `/stagingAreaMaster/detailPage`, {
      method: "POST",
      params,

      ...options,
    }),
  );
}
